import { build } from './build-info';
import { Environment } from './environment.type';

export const environment: Environment = {
    build,
    stage: 'sandbox',
    LOGIN_URL: 'https://sandbox-login.bannerflow.com',
    CLIENT_ID: 'VrXz3tVRx3vUqp2m2O0BYSeDEuM6VlSm',
    API_URLS: []
};
